import { useAppSelector } from '../../redux/useTypedSelector'
import useApi from '../../services/useApi'
import {NotificationsType} from '../../utils/notificationType'

export const useGetNotificationTypeDropdown = () => {
  const Api = useApi()
  const {isLoading} = useAppSelector((state) => state.auth)

  const {data: response, isFetching} = Api.useGetQuery(`/notifications/modules`, {
    queryId: 'product-notifications-modules',
    isToast: false,
    isErrorPageRedirection: false,
  },{
    enabled : !isLoading
  })

  return {
    NotificationsType: response?.['data'] || NotificationsType,
    loading: isFetching,
  }
}
